// src/components/CategoryCard.js
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Icons from "../../../../Config/Images";
import "./CategoryCard.css";
import CustomImageComponent from "../CustomImageComponent";
import { useMediaQuery } from "@mui/material";

const CategoryCard = ({ item, onClick, height = 350 }) => {
  // Set responsive image height based on screen width
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const is580SmallScreen = useMediaQuery("(max-width:580px)");
  const is320SmallScreen = useMediaQuery("(max-width:320px)");
  // Set heights based on screen size
  const imageHeight = is320SmallScreen
    ? "150px"
    : is580SmallScreen
    ? "180px"
    : isSmallScreen
    ? "200px"
    : "240px";
  const cardHeight = is320SmallScreen
    ? "140px"
    : is580SmallScreen
    ? "170px"
    : isSmallScreen
    ? "190px"
    : "240px";

  const handleClick = () => {
    if (onClick) {
      onClick(item);
      // window.scrollTo(0, 0);
    }
  };
  return (
    <div
      className="card-subcategories"
      sx={{ height, cursor: "pointer" }}
      // onClick={() => onClick(item)}
      onClick={handleClick}
    >
      {/* Use CustomImageComponent outside CardMedia */}
      {/* <div style={{ height: "260px" }}> */}
      <div style={{ height: cardHeight }}>
        <CustomImageComponent
          src={item?.image}
          width={"100%"}
          // height={"260px"}
          height={imageHeight}
          className="category-img"
        />
      </div>
      <div className="lower-card-div">
        <p className="paragraph-category-name">{item?.name || "-"}</p>
        <div className="expore-div">
          <p className="paragraph-category-explore-txt">Explore</p>
          <div className="right-arrow-explore-div">
            <img src={Icons.vectorRightIcon} alt="arrow" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;
